import {
  ACTIVE_PATIENT,
  ACTIVE_PRACTITIONER, ROLE_CHANGED,
  SET_ACTIVE_PATIENT_NAME
} from "../constants/types/roleType";

const initialState = {
  role: null,
  activePatientId: 0,
  activePractitionerId: 0,
  activePatientName:'',
  activeCartItem: [],
};
export const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ROLE_CHANGED:
      return {
        ...state,
        role: action.payload,
      };
    case ACTIVE_PATIENT: {
      return {
        ...state,
        activePatientId: action.payload,
      };
    }
    case SET_ACTIVE_PATIENT_NAME:{
      return {
        ...state,
        activePatientName: action.payload,
      };
    }
    case ACTIVE_PRACTITIONER: {
      return {
        ...state,
        activePractitionerId: action.payload,
      };
    }
   

    default:
      return state;
  }
};
